module.exports = __webpack_public_path__ + "img/icon_classify07.a66fb785.png";